<div class="dialog-container-main">
  <!-- <div class="dialog-header">
    <h2 mat-dialog-title>Login</h2>
    <button mat-button [mat-dialog-close]="status"><span class="material-icons">close</span></button>
  </div> -->
  <!-- <h4 class="heading-title text-center">Cashel Family Office</h4> -->
  <br />
  <div class="logo">

    <a routerLink="/"><img src="assets/images/logo.svg" alt="" /></a>
  </div>

    <mat-dialog-content class="mat-typography">
      <div class="dialog-form-box">
        <div class="row">
         <div class="col m12 s12">
          <h5 class="text-center">{{header}}</h5>
          </div>
          <div class="col m12 s12 text-center">
           <a >{{content}}
           </a>


          </div>
        </div>


      <div class="row forget-password">
        <!-- <a href="javascript:void(0);" (click)="openDialog()">Go back to login page</a> -->
      </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="btn-col-footer">

    </mat-dialog-actions>


</div>
